import { useFormContext } from 'FrontRoyalReactHookForm';
import { type AnyObject } from '@Types';

const ErrorMessage = ({ name = '', className = '' }) => {
    const {
        formState: { errors },
    } = useFormContext<AnyObject>();

    // An error on a field array itself lands at `root`, not on the array entry. react-hook-form
    // keeps the entry for the per-item errors. Without the fallback the "total refunds are more
    // than the transaction" message never rendered, and Save disabled with nothing to explain it.
    const error = errors[name];
    const errorMessage = error?.message ?? error?.root?.message;

    return errorMessage ? <div className={`error-message ${className}`}>{errorMessage}</div> : null;
};

export default ErrorMessage;
